import React from "react";
import { useShowAfterFirstRender } from "../../../../../../common-deprecated/hooks";
import { BnbLabel, useBnbOptionalLabel } from "../../../utils/labels";
import type { CtaButtonType } from "../../../../../../common-deprecated/server/data/FormatBnbCtas";
import useCtaButton from "../../../hooks/shared/actions/useCtaButton";
import { useBnbSelector } from "../../../redux/store";
import * as Styles from "../../../../../../common-deprecated/styles/v2/toyota/custom/basket/Basket";
import useCtaList from "../../../hooks/shared/actions/useCtaList";
import Preloader, * as PreloaderStyles from "../../../../../../common-deprecated/styles/v2/toyota/custom/Preloader";
import { isRetailerApps } from "../../../../../../common-deprecated/settings/utils/commonSettingUtils";
import IconWrapper from "../../../../../../common-deprecated/styles/toyota/IconWrapper";
import IconDownload from "../../../../../../common-deprecated/svg/toyota/aem/download.svg";
import IconMail from "../../../../../../common-deprecated/svg/toyota/v1/mail.svg";
import IconFinance from "../../../../../../common-deprecated/svg/toyota/v1/calculator.svg";
import IconContactDealer from "../../../../../../common-deprecated/svg/toyota/aem/location.svg";
import IconTestDrive from "../../../../../../common-deprecated/svg/toyota/aem/testdrive.svg";
import IconBook from "../../../../../../common-deprecated/svg/toyota/aem/book.svg";
import IconReserve from "../../../../../../common-deprecated/svg/toyota/aem/reserve.svg";

const CtaButton = (props: { config: CtaButtonType }): JSX.Element => {
    const { config } = props;
    const ctaProps = useCtaButton(config);
    const { href, onClick, target, title } = ctaProps;

    let icon;
    switch (config.icon) {
        // Configurable CTAs
        case "dealer":
            icon = <IconContactDealer />;
            break;
        case "book":
            icon = <IconBook />;
            break;
        case "testdrive":
            icon = <IconTestDrive />;
            break;
        case "mail":
            icon = <IconMail />;
            break;
        case "finance":
            icon = <IconFinance />;
            break;
        case "reserve":
            icon = <IconReserve />;
            break;
        case "download":
            icon = <IconDownload />;
            break;
        default:
            icon = <IconBook />;
            break;
    }

    return (
        <Styles.CtaLink href={href} onClick={onClick} target={target} className={`build-${config.type as string}`}>
            <IconWrapper iconColor="dark">{icon}</IconWrapper>
            <Styles.CtaTitle>{title}</Styles.CtaTitle>
        </Styles.CtaLink>
    );
};

const SummaryCtas = (): JSX.Element | null => {
    const ctas = useCtaList("mainCtas");
    const show = useShowAfterFirstRender();
    const settings = useBnbSelector((state) => state.commonSettings);
    const saveConfig = useBnbSelector((state) => state.save);
    const { saving: tyCodeSaving, error: tyCodeSavingFailed } = saveConfig;
    const titleLabel = useBnbOptionalLabel("basketTitleSummaryCta");

    const hideOnApps = isRetailerApps(settings);

    if (!show || hideOnApps || !ctas.length) return null;

    return (
        <Styles.CtaWrapper>
            {tyCodeSaving && (
                <PreloaderStyles.PreloaderBackdrop>
                    <PreloaderStyles.PreLoaderWrapper>
                        <Preloader size={30} />
                    </PreloaderStyles.PreLoaderWrapper>
                </PreloaderStyles.PreloaderBackdrop>
            )}
            {titleLabel && <Styles.Title>{titleLabel}</Styles.Title>}

            {tyCodeSavingFailed ? (
                <BnbLabel label="errorSavingConfig" />
            ) : (
                <Styles.CtaItems numItems={ctas.length}>
                    {ctas.map((ctaConfig, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <Styles.CtaItem key={index} disabled={tyCodeSaving} data-testid="basketcta-button">
                            <CtaButton config={ctaConfig} />
                        </Styles.CtaItem>
                    ))}
                </Styles.CtaItems>
            )}
        </Styles.CtaWrapper>
    );
};

export default SummaryCtas;
